<template>
    <li  @click="itemClick(k)" :value='value' 
        :class="{active:k===sltIndex}" class="dropDown-item"> 
        <span> {{label}} </span>
    </li> 
</template>

<script>
    export default {
        props: ['label','value','id','type','readonly'],
        mounted(){
            this.initHandler(this);
        },
        data(){
            return{
                dataList:'',
                sltInfo:'',
                sltIndex:'',
                isShowBox:false
            }
        },
        methods:{
       
        }
    }
</script>

<style scoped lang="less">
    

</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/wkSelectOption.vue